/**
 * Handoff pastel tint rotation (docs/plans/2026-08-handoff-layout/00-OVERVIEW.md).
 * Used behind event thumbnails, avatars and club marks whenever there's no photo.
 * Order is fixed — dream pink, nintendo blue, lavender fog, cream.
 */
export const TINTS = ['#FFCCE6', '#A8D8EA', '#C6B8FF', '#FFF8EA'];

/** Deterministic tint for a stable key (id, invite code, handle, name). */
export function tintFor(key) {
  const s = String(key || '');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return TINTS[h % TINTS.length];
}

/** Tint by position, for lists that should cycle in render order. */
export function tintAt(index) {
  return TINTS[((index % TINTS.length) + TINTS.length) % TINTS.length];
}

export default tintFor;
